import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Image as ImageIcon } from 'lucide-react';
import { InfoField, listingStatusColors } from './shared';

export function UserDetailModal({ userDetail, onClose }) {
  if (!userDetail) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white dark:bg-neutral-800 rounded-2xl border dark:border-neutral-700 w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()} data-testid="user-detail-modal">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-bold text-neutral-900 dark:text-white">Details utilisateur</h2>
          <Button size="sm" variant="ghost" onClick={onClose}>Fermer</Button>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-6 text-sm">
          <InfoField label="Nom" value={`${userDetail.user.first_name} ${userDetail.user.last_name}`} />
          <InfoField label="Email" value={userDetail.user.email} />
          <InfoField label="Entreprise" value={userDetail.user.company?.name || '-'} />
          <InfoField label="TVA" value={userDetail.user.company?.vat_number || '-'} />
        </div>
        <div className="grid grid-cols-4 gap-3 mb-6">
          <div className="bg-neutral-50 dark:bg-neutral-700 rounded-lg p-3 text-center"><p className="text-lg font-bold text-[#1F3F72] dark:text-blue-300">{userDetail.stats.listings_count}</p><p className="text-[10px] text-neutral-500">Annonces</p></div>
          <div className="bg-neutral-50 dark:bg-neutral-700 rounded-lg p-3 text-center"><p className="text-lg font-bold text-[#F25C05]">{userDetail.stats.conversations_count}</p><p className="text-[10px] text-neutral-500">Conversations</p></div>
          <div className="bg-neutral-50 dark:bg-neutral-700 rounded-lg p-3 text-center"><p className="text-lg font-bold text-emerald-600">{userDetail.stats.boosts_count}</p><p className="text-[10px] text-neutral-500">Boosts</p></div>
          <div className="bg-neutral-50 dark:bg-neutral-700 rounded-lg p-3 text-center"><p className="text-lg font-bold text-purple-600">{userDetail.stats.favorites_count}</p><p className="text-[10px] text-neutral-500">Favoris</p></div>
        </div>
        {userDetail.listings.length > 0 && (
          <>
            <h3 className="text-sm font-semibold text-neutral-900 dark:text-white mb-3">Annonces ({userDetail.listings.length})</h3>
            <div className="space-y-2 mb-4">
              {userDetail.listings.map(l => (
                <div key={l.id} className="flex items-center gap-3 p-2 rounded-lg bg-neutral-50 dark:bg-neutral-700 text-sm">
                  <div className="w-10 h-10 rounded bg-neutral-200 dark:bg-neutral-600 overflow-hidden shrink-0">{l.images?.[0] ? <img src={l.images[0]} alt="" className="w-full h-full object-cover" /> : <ImageIcon className="w-4 h-4 text-neutral-400 m-auto mt-3" />}</div>
                  <div className="flex-1 min-w-0"><p className="font-medium truncate text-neutral-900 dark:text-white">{l.title}</p><p className="text-xs text-neutral-400">{l.price?.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</p></div>
                  <Badge className={`text-[10px] ${listingStatusColors[l.status] || ''}`}>{l.status}</Badge>
                </div>
              ))}
            </div>
          </>
        )}
        {userDetail.boosts.length > 0 && (
          <>
            <h3 className="text-sm font-semibold text-neutral-900 dark:text-white mb-3">Boosts ({userDetail.boosts.length})</h3>
            <div className="space-y-2">
              {userDetail.boosts.map((b) => (
                <div key={b.listing_title + '_' + b.type + '_' + (b.expires_at || '')} className="flex items-center justify-between p-2 rounded-lg bg-neutral-50 dark:bg-neutral-700 text-sm">
                  <div><p className="font-medium text-neutral-900 dark:text-white">{b.listing_title}</p><p className="text-xs text-neutral-400">{b.type}</p></div>
                  <div className="text-right"><p className="font-semibold text-emerald-600">{((b.amount_paid || 0) / 100).toFixed(2)}€</p><p className="text-[10px] text-neutral-400">{b.expires_at ? new Date(b.expires_at).toLocaleDateString('fr-FR') : ''}</p></div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
